import {
  type ExamCenterProctorType,
  ExamEventCourseStatus,
  type ExamEventExamineeStatus,
  ExamType,
  RegistrationType,
} from '@exam-center/graphql';

export const MAX_SESSIONS = 4;

export const proctorTypeLabelMap: Record<ExamCenterProctorType, string> = {
  PROCTOR_1: 'ผู้คุมสอบประเภทที่ 1',
  PROCTOR_2: 'ผู้คุมสอบประเภทที่ 2',
  PROCTOR_3: 'ผู้คุมสอบประเภทที่ 3',
};

export const EXAM_EVENT_EXAMINEE_STATUS_LABEL: Record<ExamEventExamineeStatus, string> = {
  ABSENT: 'Absent',
  CANCELED: 'Canceled',
  COMPLETED: 'Completed',
  FINISHED: 'Finished',
  IN_PROGRESS: 'In Progress',
  PENDING_RESULTS: 'Pending Results',
  PREPARE_FOR_EXAM: 'Prepare for Exam',
  PROCESSING: 'Processing',
  REGISTERED: 'Registered',
};

export const REGISTRATION_TYPE_LABEL = {
  [RegistrationType.InHouse]: 'In-house',
  [RegistrationType.Public]: 'Public',
} as const;

export const EXAM_TYPE_LABEL = {
  [ExamType.Computer]: 'Computer',
  [ExamType.Paper]: 'Paper',
} as const;

export const DOWNLOADABLE_EXAM_TYPE = [ExamType.Paper];

export const DOWNLOADABLE_COURSE_STATUSES = [
  ExamEventCourseStatus.Allocated,
  ExamEventCourseStatus.Assigned,
];
